import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React, { useState, useEffect, useRef } from 'react'
import { Link, useLocation, BrowserRouter, browserHistory as Router } from "react-router-dom"
import { withTranslation } from 'react-i18next'
import { postDataFetcher } from '../../dataFetcher'
import CONFIG_OBJECT from '../../config/config'
import App_Constants from '../../app-constants/App_Constants'
import SearchBlock from './SearchBlock/SearchBlock'
import AdvancedSearchBlock from './AdvancedSearchBlock/AdvacnedSearchBlock'
import SearchResult from './SearchResult/SearchResult'
import './RecipeFilterData.css'

const defaultState = false
const defaultpage = 1

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const BabyRecipeFinder = (props) => {

  let query = useQuery();

    const[recipefinderdata, setRecipefinderdata] = useState({
      title:'',
      searchfieldtitle: ''
    })
    const[recipefilterdata, setRecipefilterdata] = useState({      
      category:[]
    })
    const [recipeData, setRecipedata] = useState({
      apiData: {},
      hasError: false,
      showresults: false
    });    

    const [selectState, setSelectState] = useState(defaultState)   
    const [showresults, setShowresults] = useState(false) 
    const [searchdata, setSearchdata] = useState({
      categoriesdata:'',
      searchtext: ''
    })

    const [sblkvisiblestate, setSblkvisiblestate] = useState()

    const [pageNavigation, setPageNavigation] = useState(defaultpage)      

    const childRef = useRef(null)

    /* useEffect(() => {
      console.log(childRef.current, 'Parent Component');
    }) */        

    useEffect(() => {      
      setRecipefinderdata({
        title:'Search',
        searchfieldtitle: 'enter data'
      })
      setRecipefilterdata({
        category:props.fields.items
      })
      if(query.get("keyword") !== null){
        setSelectState(!defaultState)
      }        
      let brcont = document.getElementById('findercomp')       
      if(window.innerWidth <= 1024){
        setSblkvisiblestate('')
        if(hasClass(brcont,'hide')){
          brcont.classList.remove('hide')
        }
      }        
    },[])

    function hasClass(element, cls) {
      return (' ' + element.className + ' ').indexOf(' ' + cls + ' ') > -1;
    }

    const clearChekcBox = () => {      
      setSearchdata({
        categoriesdata:[],
        searchtext: ''
      })
      setSelectState(defaultState)
      setRecipedata({
        showresults: defaultState
      })
      setShowresults(defaultState)
      childRef.current.focus()
    } 
    

    const changestateHandler = () => {
        if(searchdata.categoriesdata.length === 0 && searchdata.searchtext.length === 0)
        {
          setSelectState(defaultState)
        } else {
          setSelectState(!defaultState)
        }      
    }

    const fetchdata = (data,type) => {
      setPageNavigation(defaultpage)
      if(type === 'bsearch'){
        setSearchdata({
          ...searchdata,
          searchtext: data
        })     
      } else {
        setSearchdata({ 
            ...searchdata,
            categoriesdata: data.categoriesdata
        })
      }
    }

    useEffect(() => {
      changestateHandler()
    },[searchdata])    

    const searchRecipe = (event) => {
      
      setRecipedata({
        setShowresults: !defaultState
      }) 
      if(window.innerWidth <= 1024){
        let brcont = document.getElementById('findercomp')       
        let newClassName = 'hide'
        setSblkvisiblestate('hide')
        //brcont.className('hide')
        brcont.className += " " + newClassName;
      }      
      let catdata = searchdata.categoriesdata
      let seadata = searchdata.searchtext

      if(query.get("keyword")){
        seadata = selectState ? searchdata.searchtext : query.get("keyword")
      } else {        
        seadata = searchdata.searchtext
      }
      let data      
      if(catdata.length > 0 && seadata === ''){          
          data = {
            filterIDs: JSON.stringify(catdata),
            pageNumber: pageNavigation
          }
      } 
      if(seadata !== '' && catdata.length === 0){
          query.get("keyword") ? 
            selectState ?
              data = {
                searchKeyword: seadata,
                pageNumber: pageNavigation
              }
            :
              data = {
                keyword : seadata,
                pageNumber: pageNavigation
              }
          :
            data = {
              searchKeyword: seadata,
              pageNumber: pageNavigation
            }
      } 
      if (catdata.length > 0 && seadata !== ''){
          data = {
            filterIDs: JSON.stringify(catdata),
            searchKeyword: seadata,
            pageNumber: pageNavigation
          }
      }

      // Calling REST API Url      
      let resturl

      if(query.get("keyword")){
        resturl = selectState ? CONFIG_OBJECT.RF_REST_URL: CONFIG_OBJECT.RFR_REST_URL
      } else {
        resturl = CONFIG_OBJECT.RF_REST_URL
      }

      postDataFetcher(`${resturl}${App_Constants.SC_API_KEY}`, data)
      .then(res => {
        if (res.data.HasError) {
          console.log(res.data.HasError)
        } else {        
          setRecipedata({
            apiData: res.data.Data,
            showresults: !defaultState
          })
        }
      }, err => {
        console.log(err);
      });
      
  }

  const paginate = (number) =>{
    setPageNavigation(number)    
  }

  useEffect(() => {
    query.get("keyword") ? searchRecipe() :
    selectState && searchRecipe()
    //selectState && searchRecipe()
  },[pageNavigation])

  function showResultLsit(data){
    //console.log(data)
    //setShowresults(data)
    setRecipedata({
      setShowresults: data
    }) 
    let brcont = document.getElementById('findercomp')       
    if(window.innerWidth <= 1024){
      setSblkvisiblestate('')
      if(hasClass(brcont,'hide')){
        brcont.classList.remove('hide')
      }
    }    
  }
    
    const { t } = props;

    return (
        <>
        <section className={`stage index m-scene UtilityWrap UtilityWrap-brf`} id="main">                   
          <div className={`form-container form-container-babyrecipe ${sblkvisiblestate}`}>
          <form  onSubmit={e => e.preventDefault() }>
            <SearchBlock             
              label=''
              forwardedRef={childRef}
              menuvisible={recipeData.showresults}
              fetchdata={fetchdata}
              selectState = {selectState}
              searchrecipe={() => searchRecipe(this)}
              placeholdertext={t('RecipeFinder_SearchBoxPlaceholder')}
            />
            <AdvancedSearchBlock
              menuvisible={recipeData.showresults}
              fetchdata={fetchdata}
              selectState = {selectState}
              categories={recipefilterdata.category}
              clearfields={() => clearChekcBox(this)}
              searchrecipe={() => searchRecipe(this)}              
            />  
            </form>          
          </div>
          {/* <>
            {JSON.stringify(searchdata)}
          </> */}
          { 
            recipeData.showresults && 
              <SearchResult 
                resultdata={recipeData.apiData} 
                paginate={paginate}  
                currentpage={pageNavigation}
                showresults={showResultLsit}
              />
          }          
        </section>
        <div className="newfooter">
          <span>{t('Common_FooterText')}</span>
        </div>
        </>
    );
}

export default withTranslation()(BabyRecipeFinder);